import { render, staticRenderFns } from "./volumeProductCategoryReport.vue?vue&type=template&id=84387e92&"
import script from "./volumeProductCategoryReport.vue?vue&type=script&lang=js&"
export * from "./volumeProductCategoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports